import dayjs, { Dayjs } from 'dayjs';

export const dateTimeFormat = (date: Dayjs, formart = 'YYYY-MM-DD HH:mm:ss'): string =>
  dayjs(date).format(formart);
